import { usePageTitle } from "./use-page-title";

type PageTitleProps = {
  title: string;
  titleIndex?: number;
};

/**
 * Renders nothing — just registers a page title via `usePageTitle`. Used to
 * set a title from a legacy class component, which can't call hooks
 * directly: render this as a sibling in the class's own `render()`.
 */
export function PageTitle({ title, titleIndex }: PageTitleProps) {
  usePageTitle(title, { titleIndex });
  return null;
}
